'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    // Inject the Featured Content tiles into the Content Grid at the configured indexes
    // before wiring up the portfolio behaviors so the modal slider order stays in sync.
    // If no separate featuredContent source is present, this will do nothing.
    require('./portfolio/featuredContentInjection').init();

    processInclude(require('./portfolio/portfolio'));

    var root = document.documentElement;
    var paragraphWidth = document.getElementById('portfolio-paragraph-width').value;
    root.style.setProperty(
        '--portfolio-paragraph-width', paragraphWidth
    );
});
